<script lang="ts" module>
  import { tv } from 'tailwind-variants';

  import BaseBtn from '@/ui/base/BaseBtn.svelte';
  import Icon from '@/ui/base/icon/Icon.svelte';

  export interface OpenButtonProps {
    status: boolean;
    onStatusChange?: (status: boolean) => void;
  }
</script>

<script lang="ts">
  let { status: statusProp, ...props }: OpenButtonProps = $props();

  const iconStyle = tv({
    base: 'size-4 text-c-link transition-transform duration-300',
    variants: {
      status: {
        opened: 'rotate-180',
        closed: 'rotate-0',
      },
    },
  });
</script>

<div class="p-[10px]" style="clip-path: inset(26px 0 0 0);">
  <div class="flex size-6 rounded-[12px] bg-white shadow-card"></div>
</div>
<div class="absolute top-[5px] flex h-full w-full justify-center">
  <BaseBtn
    label="Expand"
    onclick={() => {
      statusProp = !statusProp;
      props.onStatusChange?.(statusProp);
    }}
    ><Icon
      icon="KeyboardArrowDown"
      class={iconStyle({ status: statusProp ? 'opened' : 'closed' })}
    /></BaseBtn
  >
</div>
